var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtstation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 260,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 195.911h208.792V0H0v195.911z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(2.27549 0 0 -2.27549 -107.348 352.707)",
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.418 72.648l8.935-15.445.002-.001a10.681 10.681 0 0 1 9.54-5.876h59.308l-12.305 21.322h-65.48zM157.195 72.538c0 2.135-.63 4.123-1.708 5.792l-34.75 60.408a10.68 10.68 0 0 1-9.44 5.68H92.932l53.676-93 8.46 14.654c1.67 2.807 2.127 4.05 2.127 6.466M108.146 87.798l-23.99 41.553-23.992-41.553h47.982z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtstation);
export default __webpack_public_path__ + "static/media/artstation.6f60fe10c0023158f90e70927b49cb34.svg";
export { ForwardRef as ReactComponent };